import ModelFlatListCard from '@/components/ModelFlatListCard'
import React from 'react'

export default function OrganizationModels() {
    return <ModelFlatListCard />
}
